module.exports = __webpack_public_path__ + "static/media/appletuan.d5076938.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/appletuan.png
// module id = 66
// module chunks = 0